import { useMemo } from 'react';
var current = 0;
export function useUID(defaultID) {
  var uid = useMemo(() => "uid_".concat(current += 1), []);
  return defaultID || uid;
}